module.exports = __webpack_public_path__ + "img/dark-green-rectangle-table-6.a6771619.png";